import axios from "axios"

const baseUrl = `${process.env.REACT_APP_BACKEND_URL}/stats`;

export const getHomeStats = (token: string)=>{
  return axios.get(`${baseUrl}/home`,
  {headers:{
    Authorization: `Bearer ${token}`
  }});
}